import { render, staticRenderFns } from "./MvtStockListComponent.vue?vue&type=template&id=8deb3fca&scoped=true"
import script from "./MvtStockListComponent.vue?vue&type=script&lang=js"
export * from "./MvtStockListComponent.vue?vue&type=script&lang=js"
import style0 from "./MvtStockListComponent.vue?vue&type=style&index=0&id=8deb3fca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deb3fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8deb3fca')) {
      api.createRecord('8deb3fca', component.options)
    } else {
      api.reload('8deb3fca', component.options)
    }
    module.hot.accept("./MvtStockListComponent.vue?vue&type=template&id=8deb3fca&scoped=true", function () {
      api.rerender('8deb3fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/MvtStockListComponent.vue"
export default component.exports